import React from "react";

interface FormattedDateTimeProps {
  dateString: string | null | undefined;
  format?: "date-time" | "date-only" | "time-only";
  fallback?: string;
  className?: string;
}

const FormattedDateTime: React.FC<FormattedDateTimeProps> = ({
  dateString,
  format = "date-time",
  fallback = "-",
  className,
}) => {
  const formatDateTime = (dateStr: string | null | undefined): string => {
    if (!dateStr) return fallback;
    try {
      const date = new Date(dateStr);
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        return fallback;
      }

      const options: Intl.DateTimeFormatOptions = {};

      if (format === "date-only") {
        options.year = "numeric";
        options.month = "short";
        options.day = "numeric";
      } else if (format === "time-only") {
        options.hour = "2-digit";
        options.minute = "2-digit";
        options.hour12 = true;
      } else {
        // date-time (default)
        options.year = "numeric";
        options.month = "short";
        options.day = "numeric";
        options.hour = "2-digit";
        options.minute = "2-digit";
        options.hour12 = true;
      }

      return date.toLocaleString("en-US", options);
    } catch {
      return fallback;
    }
  };

  return <span className={className}>{formatDateTime(dateString)}</span>;
};

export default FormattedDateTime;

